import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatNativeDateModule } from '@angular/material/core'; 
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from '@ionic/angular';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { Router } from '@angular/router';
import { LndSuccessMsgComponent } from '../lnd-success-msg/lnd-success-msg.component';
import { AddFacultyPopupComponent } from '../add-faculty-popup/add-faculty-popup.component';


@Component({
  selector: 'app-add-program',
  templateUrl: './add-program.component.html',
  styleUrls: ['./add-program.component.scss'],
})
export class AddProgramComponent  implements OnInit {
  addProgramForm: FormGroup;
  buttonColorName: any;
  trainingTypes = ['LMS', 'Offline'];
  functionalOptions = ['Functional', 'Behavioral'];
  departments = ['Sales', 'Accounting', 'IT','Marketing'];
  bands = ['A', 'B', 'C'];
  grades = ['Leadership', 'Executive', 'Manager','Junior'];

  constructor(
    public dialogRef: MatDialogRef<AddProgramComponent>,
    private fb: FormBuilder,
    private router: Router,
    private dialog: MatDialog // Inject MatDialog
  )  {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.addProgramForm = this.fb.group({
      
      trainingType: ['', Validators.required],
      programTitle: ['', Validators.required],
      programCode: ['', Validators.required],
      lmsLink: ['',Validators.required],
      starTime: ['',Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      functionalBehavioral: ['', Validators.required],
      programDays: ['', Validators.required],
      budgetCost: ['', Validators.required],
      actualCost: ['', Validators.required],
      facultyName: ['', Validators.required],
      objective: ['', Validators.required],
      department: ['', Validators.required],
      band: ['', Validators.required],
      grade: ['', Validators.required],
      location: ['',Validators.required]
    });
  }
  ngOnInit(): void {
  
  }

  onClickAddNewFacultyPopup(){
     const dialogConfig = new MatDialogConfig();
          dialogConfig.height = '70%';
          dialogConfig.width = '70%';
          dialogConfig.data = {};
          dialogConfig.panelClass = 'custom-dialog-container';
          const dialogRef = this.dialog.open(AddFacultyPopupComponent, dialogConfig);
          dialogRef.afterClosed().subscribe(result => {
            
          });
  }

  submitProgram() {
    if (this.addProgramForm.valid) {
      console.log('Form Submitted with Data:', this.addProgramForm.value);
      this.dialogRef.close();
      const dialogRef = this.dialog.open(LndSuccessMsgComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg:"Saved Succesfully!",
          btn2: 'OK',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: true,
          showSuccessMessage: false,
          showCloseIcon: false
        }
      });
      
      dialogRef.afterClosed().subscribe(() => {
      });
    }
  }


  closeDialog() {
    this.dialogRef.close();
  }
}
